import React, { useEffect, useRef, useState } from 'react';
import Button from 'components/ui/Button';
import Input from 'components/ui/Input';
import { useTemplateEditor } from '../context/TemplateEditorContext';
import { getTemplateNameInputError } from '../utils/templateNameUtils';
import FieldCard from './FieldCard';

const FieldPanel = () => {
  const {
    fields,
    templateName,
    setTemplateName,
    addFieldAtCursor,
    renameField,
    updateFieldType,
    updateFieldName,
    updateFieldObrigatorio,
    removeField,
    editor,
    activeFieldUuid,
    clearActiveField,
    isEditMode,
  } = useTemplateEditor();
  const [collapseAllSignal, setCollapseAllSignal] = useState(0);
  const collapsedExistingOnEditLoad = useRef(false);

  useEffect(() => {
    if (!isEditMode || collapsedExistingOnEditLoad.current || fields.length === 0) {
      return;
    }
    collapsedExistingOnEditLoad.current = true;
    setCollapseAllSignal((value) => value + 1);
  }, [isEditMode, fields.length]);

  useEffect(() => {
    if (!activeFieldUuid) return;

    const card = document.getElementById(`field-card-${activeFieldUuid}`);
    if (!card) return;

    card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }, [activeFieldUuid]);

  const templateNameError = templateName.trim() ? getTemplateNameInputError(templateName) : null;

  return (
    <aside className="flex h-full min-h-0 w-full flex-col rounded-lg border border-border bg-card shadow-elevation-sm">
      <div className="shrink-0 border-b border-border p-4 space-y-4">
        <Input
          label="Nome do Modelo"
          value={templateName}
          onChange={(e) => setTemplateName(e.target.value)}
          placeholder="Ex.: Contrato de Locação"
          error={templateNameError}
          required
        />

        <Button
          type="button"
          iconName="Plus"
          className="w-full"
          onClick={addFieldAtCursor}
          disabled={!editor}
        >
          Adicionar Campo
        </Button>

        {fields.length > 0 && (
          <Button
            type="button"
            variant="outline"
            iconName="ChevronsUp"
            className="w-full"
            onClick={() => {
              setCollapseAllSignal((value) => value + 1);
              clearActiveField();
            }}
          >
            Recolher todos
          </Button>
        )}
      </div>

      <div className="min-h-0 flex-1 overflow-y-auto p-4 space-y-3">
        {fields.length === 0 ? (
          <p className="text-sm text-muted-foreground text-center py-8 px-2">
            Nenhum campo adicionado. Clique em &quot;Adicionar Campo&quot; ou digite um token como{' '}
            <span className="font-mono text-foreground">{'{ABC}'}</span> no editor.
          </p>
        ) : (
          fields.map((field) => (
            <FieldCard
              key={field.uuid}
              field={field}
              isActive={activeFieldUuid === field.uuid}
              collapseSignal={collapseAllSignal}
              onRename={renameField}
              onTypeChange={updateFieldType}
              onFieldNameChange={updateFieldName}
              onObrigatorioChange={updateFieldObrigatorio}
              onRemove={removeField}
            />
          ))
        )}
      </div>
    </aside>
  );
};

export default FieldPanel;
